module.exports = __webpack_public_path__ + "static/media/honor3.d5ccfd4c.png";